import styled from "styled-components";
import { mediaQueryMaxMedium } from "../../mediaQuery";

export { NavigationBar } from "./NavigationBar";
export { AccountSwitcherProvider } from "../MmAccountSwitcher/AccountSwitcherContext";
// Wraps the open menu button to display the menu on smaller screens.
export const SidebarButtonWrapper = styled.div`
  display: none;
  ${mediaQueryMaxMedium} {
    display: block;
  }
`;
